/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Impact Evaluation Container 
Author: Deimos Space UK

Version: 1.0
*/

import React, { useState, useEffect } from "react";
import {
  Col, Container, Row, Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import IndexValue from "../components/stadistics/IndexValue";
import ShareCapacity from "../components/stadistics/ShareCapacity";
import ShareTotalCapacity from "../components/stadistics/ShareTotalCapacity";
import IndexTotalMissionPhase from "../components/pieChart/IndexTotalMissionPhase";
import DebrisIndexPerSpacecraft from "../components/pieChart/DebrisIndexPerSpacecraft";
import IndexTimeEvaluation from "../components/barChart/IndexTimeEvaluation";
import DifferentPMD from "../components/barChart/DifferentPMD.js";
import SpacecraftBarchart from "../components/barChart/SpacecraftBarchart";
import DebrisReferencesIndex from "../components/lineChart/DebrisReferencesIndex";
import EffectMap from "../components/imageChart/EffectMap";
import { useParams } from "react-router-dom";
import { getPetition } from "../../../api/api";
import { useLocation } from 'react-router-dom';

export default function ImpactEvaluation() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [constellation, setConstellation] = useState(false)
  const [launcher, setLauncher] = useState(false)
  const [spacecraftId, setSpacecraftId] = useState(null)
  const [spacecraftIdArray, setSpacecraftIdArray] = useState([])
  const [stadisticsData, setStadisticsData] = useState({})
  const [loading, setLoading] = useState(false)
  const [missionName, setMissionName] = useState('')
  const [missionVersion, setMissionVersion] = useState('')
  const [planeNumber, setPlaneNumber] = useState(0)
  const [missionRegion, setMissionRegion] = useState('')
  const location = useLocation();

  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const { id } = useParams();

  useEffect(() => {
    setLoading(true)

    getPetition(`/api/mission?mission_id=${id}`)
      .then((data) => {
        if (data) {
          setMissionName(data?.name)
          setMissionVersion(data?.version)
          setMissionRegion(data?.orbital_region)
        }
        if (data && data?.architecture === 'launcher') {
          setLauncher(true)
        } else {
          setLauncher(false)
        }
        if (data && data?.architecture === 'constellation') {
          setConstellation(true)
        } else {
          setConstellation(false)
        }
        setMissionName(data?.name)

      })
      .catch((error) => {
      })
    getPetition(`/api/mission/object_data?mission_id=${id}`)
      .then((data) => {
        formatSpacecraftId(data)
      })
      .catch((error) => {
        console.log(error)
      })

  }, [id]);

  useEffect(() => {
    if (constellation) {
      if (spacecraftId === null) {
        getPetition(`/api/debris_index/debris_indices_for_mission?mission_id=${id}`)
          .then((data) => {
            setStadisticsData(data)
            setLoading(false)
          })
          .catch((error) => {
            setLoading(false)
          })
      }
      else {
        getPetition(`/api/debris_index/debris_indices_for_spacecraft?spacecraft_id=${spacecraftId}`)
          .then((data) => {
            setStadisticsData(data)
            setLoading(false)
          })
          .catch((error) => {
            setLoading(false)
          })
      }
    } else if (spacecraftIdArray.length) {
      getPetition(`/api/debris_index/debris_indices_for_spacecraft?spacecraft_id=${spacecraftIdArray[0]}`)
        .then((data) => {
          setStadisticsData(data)
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false)
        })
    }
  }, [constellation, id, spacecraftId, spacecraftIdArray]);


  const formatSpacecraftId = (data) => {
    const spacecraftId = []
    data?.map((item) => {
      if (item.space_vehicle_id) {
        spacecraftId.push(item.space_vehicle_id)
      }
    })
    setSpacecraftIdArray(spacecraftId)
  }

  return (
    <Container>
      {
        location.pathname.includes('output') && (
          <Row>
            <Col xs={12}>
              <h3 style={{ color: '#003247' }}>Mission {missionName}</h3>
              <h6 style={{ color: '#003247' }}>Version: {missionVersion}</h6>
            </Col>

          </Row>
        )
      }

      <Row className="pt-3">
        {
          !id && <Col>
            <h3 style={{ color: "#003247" }}>Environmental Impact Evaluation</h3>
          </Col>
        }
        {
          constellation &&
          <Col>
            <Dropdown className="float-right" isOpen={dropdownOpen} toggle={toggle} >
              <DropdownToggle style={{ background: "#003247" }} caret>{spacecraftId ? `Plane ${planeNumber + 1}` : 'Constellation'}</DropdownToggle>
              <DropdownMenu >
                <DropdownItem onClick={() => setSpacecraftId(null)}>Constellation</DropdownItem>
                {
                  spacecraftIdArray?.map((item, index) => {
                    return (
                      <DropdownItem onClick={() => {
                        setSpacecraftId(item)
                        setPlaneNumber(index)
                      }
                      }>Plane {index + 1}</DropdownItem>
                    )
                  })
                }
              </DropdownMenu>
            </Dropdown>
          </Col>
        }

      </Row>

      <Row className="pt-3">

        <Col xs={12} md={6}>
          <IndexValue
            loading={loading}
            data={stadisticsData}
          />
        </Col>

        <Col xs={12} md={6} >
          <ShareTotalCapacity
            loading={loading}
            data={stadisticsData}
          />
        </Col>

        {
          !launcher &&
          <Col xs={12} md={12} xl={12}>
            <IndexTotalMissionPhase
              spacecraftIdArray={spacecraftIdArray}
              spacecraftId={spacecraftId}
              constellation={constellation}
              missionId={id}
            />
          </Col>
        }

      </Row>
      {
        (constellation && spacecraftId === null) &&
        <Row className="pt-3" >
          <Col xs={12} md={6}>
            <DebrisIndexPerSpacecraft />
          </Col>
          <Col xs={12} md={6}>
            <SpacecraftBarchart />
          </Col>
        </Row>
      }
      {
        !launcher &&
        <Row className="pt-3">
          <Col xs={12} lg={(!constellation || spacecraftId !== null) ? 6 : 12}>
            <DifferentPMD
              spacecraftIdOrigin={spacecraftIdArray}
              spacecraftId={spacecraftId}
              missionName={missionName}
              constellation={constellation}
              missionId={id}
            />
          </Col>
          {
            (!constellation || spacecraftId !== null) &&
            <Col xs={12} lg={6}>
              <IndexTimeEvaluation
                spacecraftId={spacecraftId}
                spacecraftIdOrigin={spacecraftIdArray}
                constellation={constellation}
              />
            </Col>
          }

        </Row>
      }

      <Row className="pt-3">

        <Col>
          <DebrisReferencesIndex
            missionName={missionName}
            spacecraftIdArray={spacecraftIdArray}
            spacecraftId={spacecraftId}
            constellation={constellation}
            missionId={id}
          />
        </Col>
      </Row>
      {
        (!constellation || spacecraftId !== null ) && !launcher &&
        <Row className="pt-3">
          <Col>
            <EffectMap
              constellation={constellation}
              spacecraftIdOrigin={spacecraftIdArray}
              spacecraftId={spacecraftId}
              region={missionRegion}
            />
          </Col>
        </Row>
      }

    </Container>
  );
}
